<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/sys/linXuanChannel/list' }"
        >渠道审批</el-breadcrumb-item
      >
    </el-breadcrumb>
    <el-form
        class="flex-item role-form"
        ref="validateForm"
        :model="form"
        size="mini"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="200px"
    >
      <el-row>
        <!--<el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="渠道申报基础信息" name="1">-->
            <el-col :span="8">
              <el-form-item label="统一社会信用代码:" prop="channelName">
                <el-input value="91310106575864243X" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业名称:" prop="channelName">
                <el-input value="测试公司" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业官网域名:" prop="channelName1">
                <el-input value="www.ccg.com" readonly></el-input>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8">
              <el-form-item label="渠道编码:" prop="channelName">
                <el-input value="BJSK" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="渠道名称:" prop="channelName">
                <el-input value="测试渠道A" readonly></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="企业简称:" prop="channelName">
                <el-input value="测试渠道" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经营模式:" prop="channelName">
                <el-input value="线上" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="线上平台名称:" prop="domain">
                <el-input value="测试" readonly></el-input>
              </el-form-item>
            </el-col>
           <!-- <el-col :span="8">
              <el-form-item label="主营品牌:" prop="channelName1">
                <el-input value="联想、小米" readonly></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="注册资金(万元):" prop="technicalEmail">
                <el-input value="5000" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法定代表人:" prop="channelName">
                <el-input value="张荣" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法定代表人联系电话:" prop="technicalEmail">
                <el-input value="15892356312" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业银行开户行名称:" prop="channelName">
                <el-input value="北京市海淀区知春路工商银行支行" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业银行帐号:" prop="channelName">
                <el-input value="622234568257856554454" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="2025年企业销售额(万元):" prop="technicalEmail">
                <el-input value="8000" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业注册地址:" prop="channelNo">
                <el-input value="北京市海淀区知春路" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册地所在区:" prop="companyName">
                <el-input value="北京海淀区" readonly></el-input>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8">
              <el-form-item label="企业咨询电话:" prop="channelName1">
                <el-input value="010-88868888" readonly></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="业务联系人姓名:" prop="technicalEmail">
                <el-input value="李米" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务联系人电话:" prop="technicalEmail">
                <el-input value="13755899898" readonly></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
               <el-form-item label="业务联系人邮箱:" prop="technicalEmail">
                 <el-input value="sw.@mail.com" readonly></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="8">
               <el-form-item label="技术联系人姓名:" prop="technicalEmail">
                 <el-input value="刘小明" readonly></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="8">
               <el-form-item label="技术联系人电话:" prop="technicalEmail">
                 <el-input value="13855556333" readonly></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="8">
               <el-form-item label="技术联系人邮箱:" prop="technicalEmail">
                 <el-input value="js@mail.com" readonly></el-input>
               </el-form-item>
             </el-col>-->
            <el-col :span="24">
              <el-form-item label="经营范围:" prop="businessEmail">
                <el-input value="通讯设备销售,移动终端设备销售,电子产品销售,家用电器销售" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="企业简介:" prop="technicalPerson">
                <el-input type="textarea" value="公司主营产品涵盖计算机及辅助设备、移动终端、智能穿戴设备、电子元器件、安防数码产品等全品类数码好物，同时延伸提供设备维修、系统安装、技术咨询等配套服务，满足客户多元化需求。" :rows="2" readonly></el-input>
              </el-form-item>
            </el-col>
          <!--</el-collapse-item>-->
          <!--<el-collapse-item title="渠道申报材料" name="2">-->
            <el-col :span="24">
              <el-form-item label="企业上传资料:" prop="technicalEmail">
                <el-link type="primary" @click="download">销售企业信息汇总表.xls&nbsp;&nbsp;&nbsp;</el-link>
                <el-link type="primary" @click="download">参与补贴实施的门店信息汇总表.xls&nbsp;&nbsp;&nbsp;</el-link>
                <el-link type="primary" @click="download">营业执照复印件.pdf&nbsp;&nbsp;&nbsp;</el-link><br>
                <el-link type="primary" @click="download">企业《信用信息报告》.pdf&nbsp;&nbsp;&nbsp;</el-link>
                <el-link type="primary" @click="download">承诺函.pdf&nbsp;&nbsp;&nbsp;</el-link>
                <el-link type="primary" @click="download">政策实施方案.pdf&nbsp;&nbsp;&nbsp;</el-link>
                <el-link type="primary" @click="download">银行开户许可证复印件.pdf&nbsp;&nbsp;&nbsp;</el-link>
              </el-form-item>
            </el-col>
         <!-- </el-collapse-item>-->
          <!--<el-collapse-item title="商户申报材料" name="3" v-if="isShowHeDui===true && userName==='test2'">-->
            <!--<el-col :span="24">
              <el-form-item prop="technicalEmail">
                <el-link type="primary" @click="download">商户申报材料.zip</el-link>
              </el-form-item>
            </el-col>-->
            <!--<el-col :span="24">
              <el-form-item label="商户资料核对结果:" prop="technicalEmail">
                <span>商户总数：申报10个，通过8个，不通过2个；门店数：申报20个，通过18个，不通过2个；</span><br>
                <span><el-link type="primary">导出不通过商户及门店列表（包含不通过原因）.xls</el-link></span><br>
                <span><el-link type="primary">导出通过商户及门店列表.xls</el-link></span>
              </el-form-item>
            </el-col>
          </el-collapse-item>-->
          <!--<el-collapse-item title="商户申报材料" name="4" v-if="userName==='test3'">
              <el-table class="flex-item" v-loading="tableLoading" :data="tableList1" size="small" height="100%" style="width: 100%; height: 100%"
                        @selection-change="handleSelectionChange">
                <el-table-column prop="merchant_name" label="销售企业名称" align="center"></el-table-column>
                <el-table-column prop="merchant_number" label="统一社会信用代码" align="center"></el-table-column>
                <el-table-column prop="diqu" label="所属地区" align="center"></el-table-column>
                <el-table-column prop="merchant_address" label="注册地址" align="center"></el-table-column>
                <el-table-column prop="jituan" label="所属集团" align="center"></el-table-column>
                <el-table-column prop="guimo" label="企业规模" align="center"></el-table-column>
                <el-table-column prop="liaxiren" label="联系人" align="center"></el-table-column>
                <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="file_name" label="上传资料" align="center">
                  <template slot-scope="scope">
                    <div class="file-item" v-for="(file, index) in scope.row.fileList" :key="index">
                      <el-link type="primary" @click="download">{{ file }}</el-link>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="store_num" label="门店数量" align="center"></el-table-column>
                <el-table-column prop="audit_state" label="操作" align="center">
                  <el-button @click.native.prevent="openDialog(scope)" type="text" size="small" >查看对应门店</el-button>
                </el-table-column>
              </el-table>
          </el-collapse-item>
        </el-collapse>-->
        <el-col :span="24">
          <el-form-item label="审批记录:" prop="technicalPerson">
            <el-table border class="flex-item" v-loading="tableLoading" :data="tableList2" size="small" style="width: 100%; height: 100%"
                      @selection-change="handleSelectionChange">
              <el-table-column prop="audit_type" label="申报类型" align="center"></el-table-column>
              <el-table-column prop="audit_time" label="审批时间" align="center"></el-table-column>
              <el-table-column prop="audit_state" label="审批状态" align="center"></el-table-column>
              <el-table-column prop="audit_desc" label="审批意见" align="center"></el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="userName==='test3' && operator!='detail'">
          <el-form-item label="初审状态:" prop="technicalPerson">
            <el-input type="text" value="通过" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="userName==='test3' && operator!='detail'">
          <el-form-item label="初审意见:" prop="technicalPerson">
            <el-input type="text" value="通过" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="userName==='test2' && operator!='detail'">
          <el-form-item label="初审意见:" prop="technicalPerson">
            <el-input type="textarea" :rows="2" value="通过"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="userName==='test3' && operator!='detail'">
          <el-form-item label="复审意见:" prop="technicalPerson">
            <el-input type="textarea" :rows="2" v-model="inputValue"></el-input>
          </el-form-item>
        </el-col>
       <!-- <el-col :span="24" v-if="userName==='test3'">
          <el-form-item label="通知实施日期:" prop="technicalPerson">
            <el-input type="text" value="2026-01-03"></el-input>
          </el-form-item>
        </el-col>-->
        <!--<el-col :span="12" v-if="userName==='test3'">
          <el-form-item label="公示起始日期:" prop="technicalPerson">
            <el-input type="text" value="2026-01-03"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="userName==='test3'">
          <el-form-item label="公示结束日期:" prop="technicalPerson">
            <el-input type="text" value="2026-01-06"></el-input>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <el-button size="small" @click="back">返回</el-button>
      <el-button size="small" type="primary" @click="hedui" v-if="userName==='test2' && operator!='detail'">接口核对资料</el-button>
      <el-button size="small" type="primary" @click="save" v-if="userName==='test2' && operator!='detail'">部分通过</el-button>
      <el-button size="small" type="primary" @click="save" v-if="userName==='test2' && operator!='detail'">全部通过</el-button>
      <el-button size="small" type="primary" @click="save" v-if="userName==='test2' && operator!='detail'">驳回</el-button>
      <el-button size="small" type="primary" @click="save" v-if="userName==='test3' && operator!='detail'">通过</el-button>
      <el-button size="small" type="primary" @click="save" v-if="userName==='test3' && operator!='detail'">不通过</el-button>
    </div>
    <el-dialog
        title="线上参与补贴实施的门店信息汇总表"
        :visible.sync="dialogVisible"
        width="80%" height="50%"
        :show-close="false">
      <el-table
          class="flex-item"
          v-loading="detailTableLoading"
          :data="merchantTableList"
          size="small"
          height="350px"
          style="width: 100%; height: 100%"
      >
        <el-table-column prop="merchant_no" fixed label="门店编号" align="center"> </el-table-column>
        <el-table-column prop="merchant_name" fixed label="门店名称" align="center"> </el-table-column>
        <el-table-column prop="merchant_number" fixed label="统一社会信用代码" align="center"> </el-table-column>
        <el-table-column prop="diqu" fixed label="所属地区" align="center"> </el-table-column>
        <el-table-column prop="merchant_address" fixed label="门店经营地址" align="center"> </el-table-column>
        <el-table-column prop="file_name" label="上传资料" align="center" min-width="180px">
          <template slot-scope="scope">
            <div class="file-item" v-for="(file, index) in scope.row.fileList" :key="index">
              <el-link type="primary" @click="download">{{ file }}</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  list
} from "@/api/system/linXuanChannel/linXuanChannel";

export default {
  name: "index",
  data() {
    return {
      inputValue:'',
      userName:'',
      isShowHeDui:'false',
      dialogVisible:false,
      operator:'',
      activeNames: ['1','2','3','4','5'],
      tableList2:[
        {'audit_type':'渠道遴选','audit_time':'2026-01-08 13:12:31','audit_state':'通过','audit_desc':'同意'},{'audit_type':'渠道遴选','audit_time':'2026-01-07 13:12:31','audit_state':'驳回','audit_desc':'注册地址填写错误'}],
      merchantTableList:[{'merchant_no':'1233','merchant_name':'商户A','merchant_number':'9556233122222566', 'diqu':'北京市海淀区',
        'merchant_address':'北京市海淀区知春路',
        'fileList':['申请参与政策说明.pdf','营业执照复印件.pdf','企业《信用信息报告》.pdf','同意函.pdf','承诺函.pdf']},
        {'merchant_no':'2355','merchant_name':'商户B','merchant_number':'9556233122222566', 'diqu':'北京市海淀区',
          'merchant_address':'北京市海淀区知春路',
          'fileList':['申请参与政策说明.pdf','营业执照复印件.pdf','企业《信用信息报告》.pdf','同意函.pdf','承诺函.pdf']}],
      tableList1:[{'merchant_name':'商户A','merchant_number':'9556233122222566', 'diqu':'北京市海淀区',
        'merchant_address':'北京市海淀区知春路','jituan':'阿里巴巴集团','xingzhi':'大型','guimo':'股份合作企业',
        'liaxiren':'张XX','phone':'1586355562',
        'fileList':['申请参与政策说明.pdf','营业执照复印件.pdf','企业《信用信息报告》.pdf','同意函.pdf','承诺函.pdf'],'store_num':'2'},
        {'merchant_name':'商户B','merchant_number':'9556233122222588', 'diqu':'北京市丰台区',
          'merchant_address':'北京市丰台区亦庄','jituan':'京东','xingzhi':'大型','guimo':'股份合作企业',
          'liaxiren':'刘XX','phone':'1586355562',
          'fileList':['申请参与政策说明.pdf','营业执照复印件.pdf','企业《信用信息报告》.pdf','同意函.pdf','承诺函.pdf'],'store_num':'2'}]
    };
  },
  mounted() {
    this.operator=this.$route.params.operator;
    this.userName=this.$store.state.token;
  },
  methods: {
    openDialog(scope) {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleChange(val) {
      console.log(val);
    },
    hedui(){
      this.isShowHeDui=true;
    },
    back() {
      this.$router.go(-1);
    },
    save(){
      this.back();
    },
    download(){
      this.$message('开发中，点击会直接打开文件预览');
    }
  },
};
</script>

<style scoped>
.el-card {
  height: 100%;
}

.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.role-form {
  margin: 15px 0;
}

.el-form-item {
  margin-bottom: 7px;
}
.el-form-item__label {
  line-height: 1.0;
}
.el-form-item__content {
  line-height: 1.0;
}
/* 纯::v-deep实现弹窗标题居中，无需修改模板结构 */
::v-deep .el-dialog__header {
  text-align: center; /* 让头部内容整体居中 */
}

::v-deep .el-dialog__title {
  float: none; /* 取消默认的左浮动，才能生效居中 */
  font-weight: 600; /* 可选：加粗标题，视觉更突出 */
}

/* 可选：调整标题与关闭按钮（若显示）的间距，当前弹窗隐藏了关闭按钮可忽略 */
::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 15px;
  right: 20px;
}
</style>